export default [
  // {
  //   path: '/om-livet',
  //   name: 'om-livet',
  //   component: () =>
  //     import(/* webpackChunkName: "Facts" */ '../views/PageChild.vue'),
  //   meta: { pageId: 283, scrollTop: true, pageName: 'Om Livet i havet' }
  // },
  {
    path: '/bestall-falthandbok',
    name: 'bestall-falthandbok',
    component: () =>
      import(/* webpackChunkName: "Facts" */ '../views/PageChild.vue'),
    meta: {
      pageId: 3530,
      scrollTop: true,
      pageName: 'Fälthandboken Växter och djur i Östersjön'
    }
  },
  {
    path: '/rapportera-fynd',
    name: 'rapportera-fynd',
    component: () =>
      import(/* webpackChunkName: "Facts" */ '../views/PageChild.vue'),
    meta: {
      pageId: 3580,
      scrollTop: true,
      pageName: 'Så rapporterar du fynd'
    }
  },
  {
    path: '/redaktion',
    name: 'redaktion',
    component: () =>
      import(/* webpackChunkName: "Facts" */ '../views/PageChild.vue'),
    meta: {
      pageId: 3682,
      scrollTop: true,
      pageName: 'Redaktion'
    }
  },
  {
    path: '/medverkande-experter',
    name: 'medverkande-experter',
    component: () =>
      import(/* webpackChunkName: "Facts" */ '../views/PageChild.vue'),
    meta: {
      pageId: 3685,
      scrollTop: true,
      pageName: 'Medverkande experter'
    }
  },
  {
    path: '/engagera-dig',
    name: 'engagera-dig',
    component: () =>
      import(/* webpackChunkName: "Facts" */ '../views/PageChild.vue'),
    meta: {
      pageId: 3683,
      scrollTop: true,
      pageName: 'Engagera dig'
    }
  },
  {
    path: '/om-livet',
    name: 'om-livet',
    component: () =>
      import(
        /* webpackChunkName: "PageChildAbout" */ '../views/PageChildAbout.vue'
      ),
    meta: {
      pageId: 3262,
      scrollTop: true,
      pageName: 'Om livet'
    }
  },
  {
    path: '/quiz',
    name: 'quiz',
    component: () =>
      import(
        /* webpackChunkName: "PageChildQuiz" */ '../views/PageChildQuiz.vue'
      ),
    meta: {
      pageId: 3700,
      scrollTop: true,
      pageName: 'Quiz'
    }
  }
]
